module.exports = __webpack_public_path__ + "static/About me - mobile - 1-77bee45e945b8dc5cd48f3a4ac9fb270.jpg";